module.exports = __webpack_public_path__ + "media/images/SmartInsights-illustration-041eba7bc13aa1e874d65834a8791bde.png";